import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { i18n } from "@/i18n";
import { mapState } from "vuex";

export default {
    beforeMount () {
        this.$store.dispatch('adminAppViewDashboard/fetchAppStats')
            .then((x) => {
                setTimeout(() => {
                    this.generateGraph();
                }, 1000)
            })
            .catch((e) => console.log(e.toString()));
        this.$store.dispatch('adminAppViewDashboard/fetchAppStatsByDay')
            .then((x) => {
                setTimeout(() => {
                    this.generateBars();
                }, 1000)
            })
            .catch((e) => console.log(e.toString()));
        this.$store.dispatch('adminAppViewDashboard/fetchLastUsers');
        this.$store.dispatch('adminAppViewDashboard/fetchTopUsers');
    },
    components: {
        top,
        navigation,
        bottom
    },
    computed: {
        ...mapState('adminAppViewDashboard', {
            appStatistics: state => state.appStatistics,
            appStatisticsLoaded: state => state.appStatisticsLoaded,
            appStatisticsByDay: state => state.appStatisticsByDay,
            appStatisticsByDayLoaded: state => state.appStatisticsByDayLoaded,
            lastUsers: state => state.lastUsers,
            lastUsersLoaded: state => state.lastUsersLoaded,
            topUsers: state => state.topUsers,
            topUsersLoaded: state => state.topUsersLoaded,
        }),
    },
    methods: {
        generateGraph() {

            let vm = this;

            "use strict";

            // Class definition
            let KTWidgets = function() {

                let _initMixedWidget16 = function() {
                    let element = document.getElementById("kt_mixed_widget_16_chart");
                    let height = parseInt(KTUtil.css(element, 'height'));

                    if (!element) {
                        console.log("no element!")
                        return;
                    }

                    let options = {
                        series: [vm.appStatistics.total_logins, vm.appStatistics.total_tags, vm.appStatistics.total_users, vm.appStatistics.total_visits],
                        chart: {
                            height: height,
                            type: 'radialBar',
                        },
                        plotOptions: {
                            radialBar: {
                                hollow: {
                                    margin: 0,
                                    size: "30%"
                                },
                                dataLabels: {
                                    showOn: "always",
                                    name: {
                                        show: false,
                                        fontWeight: "700",
                                    },
                                    value: {
                                        color: KTApp.getSettings()['colors']['gray']['gray-700'],
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        offsetY: 10,
                                        show: true
                                    },
                                    total: {
                                        show: true,
                                        label: 'Total',
                                        fontWeight: "bold",
                                        formatter: function (w) {
                                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                                            return '60%';
                                        }
                                    }
                                },
                                track: {
                                    background: KTApp.getSettings()['colors']['gray']['gray-100'],
                                    strokeWidth: '100%'
                                }
                            }
                        },
                        colors: [
                            KTApp.getSettings()['colors']['theme']['base']['info'],
                            KTApp.getSettings()['colors']['theme']['base']['danger'],
                            KTApp.getSettings()['colors']['theme']['base']['success'],
                            KTApp.getSettings()['colors']['theme']['base']['primary']
                        ],
                        stroke: {
                            lineCap: "round",
                        },
                        labels: ["Progress"]
                    };

                    let chart = new ApexCharts(element, options);
                    chart.render();
                }
                return {
                    init: function () {
                        _initMixedWidget16();
                    }
                }
            }();

            jQuery(document).ready(function() {
                KTWidgets.init();
            });

        },
        generateBars() {

            let vm = this;

            "use strict";

            // Class definition
            let KTWidgets = function() {

                var _initChartsWidget1 = function() {
                    var element = document.getElementById("kt_charts_widget_1_chart");

                    if (!element) {
                        return;
                    }

                    var options = {
                        series: [{
                            name: i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_accounts_creation'),
                            data: [
                                vm.appStatisticsByDay[0].usersRegistered,
                                vm.appStatisticsByDay[1].usersRegistered,
                                vm.appStatisticsByDay[2].usersRegistered,
                                vm.appStatisticsByDay[3].usersRegistered,
                                vm.appStatisticsByDay[4].usersRegistered,
                                vm.appStatisticsByDay[5].usersRegistered
                            ]
                        }, {
                            name: i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_logins'),
                            data: [
                                vm.appStatisticsByDay[0].usersLogin,
                                vm.appStatisticsByDay[1].usersLogin,
                                vm.appStatisticsByDay[2].usersLogin,
                                vm.appStatisticsByDay[3].usersLogin,
                                vm.appStatisticsByDay[4].usersLogin,
                                vm.appStatisticsByDay[5].usersLogin
                            ]
                        }],
                        chart: {
                            type: 'bar',
                            height: 350,
                            toolbar: {
                                show: false
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: ['30%'],
                                endingShape: 'rounded'
                            },
                        },
                        legend: {
                            show: false
                        },
                        dataLabels: {
                            enabled: false
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ['transparent']
                        },
                        xaxis: {
                            categories: [
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': ""}),
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': "-1"}),
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': "-2"}),
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': "-3"}),
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': "-4"}),
                                i18n.t('administration.admin.app_dashboard.application_recent_stats_graph_day_shortcut', {'minusDay': "-5"})
                            ],
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false
                            },
                            labels: {
                                style: {
                                    colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                                    fontSize: '12px',
                                    fontFamily: KTApp.getSettings()['font-family']
                                }
                            }
                        },
                        yaxis: {
                            labels: {
                                style: {
                                    colors: KTApp.getSettings()['colors']['gray']['gray-500'],
                                    fontSize: '12px',
                                    fontFamily: KTApp.getSettings()['font-family']
                                }
                            }
                        },
                        fill: {
                            opacity: 1
                        },
                        states: {
                            normal: {
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            },
                            hover: {
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            },
                            active: {
                                allowMultipleDataPointsSelection: false,
                                filter: {
                                    type: 'none',
                                    value: 0
                                }
                            }
                        },
                        tooltip: {
                            style: {
                                fontSize: '12px',
                                fontFamily: KTApp.getSettings()['font-family']
                            },
                            y: {
                                formatter: function(val) {
                                    return val//return "$" + val + " thousands"
                                }
                            }
                        },
                        colors: [KTApp.getSettings()['colors']['theme']['base']['primary'], KTApp.getSettings()['colors']['gray']['gray-300']],
                        grid: {
                            borderColor: KTApp.getSettings()['colors']['gray']['gray-200'],
                            strokeDashArray: 4,
                            yaxis: {
                                lines: {
                                    show: true
                                }
                            }
                        }
                    };

                    var chart = new ApexCharts(element, options);
                    chart.render();
                }
                return {
                    init: function () {
                        _initChartsWidget1();
                    }
                }
            }();

            jQuery(document).ready(function() {
                KTWidgets.init();
            });

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-view-dashboard/master/app-view-dashboard.js